/* ButtonGroup.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ButtonGroup.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
var buttonGroupStyle = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
var buttonGroupStyleUnbounded = null;
var buttonGroupStyleBeforeVisualRefresh = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
var buttonGroupStyleBeforeVisualRefreshUnbounded = null;
export function ToolbarButtonGroup(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    className: ax([fg('platform-visual-refresh-icons') ? "_zulp1b66 _1e0c116y _4cvr1h6o" : "_1e0c116y _4cvr1h6o", fg('platform-visual-refresh-icons') ? "_11ko1txw _1p8dglyw _89rs1b66" : "_11ko1txw _1p8dglyw"])
  }, children);
}